var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0V0z",
    fill: "#1565C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95 2l.37 1.14h1.2l-.97.7.37 1.14-.97-.7-.96.7.36-1.13-.96-.7h1.2L8.94 2zM4.04 4.04l1.07.54.84-.84-.18 1.18 1.06.54-1.18.19-.19 1.18-.54-1.06-1.18.18.84-.84-.54-1.07zM2 8.95l1.14-.37v-1.2l.7.97L4.99 8l-.7.96.7.97-1.13-.37-.7.97v-1.2L2 8.95zM4.04 13.86l.54-1.06-.84-.85 1.18.19.54-1.07.19 1.19 1.18.18-1.06.55.18 1.18-.84-.85-1.07.54zM8.95 15.9l-.37-1.14h-1.2l.97-.7L8 12.92l.96.7.97-.7-.37 1.14.97.7h-1.2l-.37 1.14zM13.86 13.86l-1.06-.54-.85.85.19-1.18-1.07-.55 1.19-.18.18-1.19.55 1.07 1.18-.19-.85.85.54 1.06zM15.9 8.95l-1.14.37v1.2l-.7-.97-1.14.37.7-.97-.7-.96 1.14.36.7-.96v1.2l1.14.36zM13.86 4.04l-.54 1.07.85.84-1.18-.18-.55 1.06-.18-1.18-1.19-.19 1.07-.54-.19-1.18.85.84 1.06-.54z",
    fill: "#FDD835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.cc1cffe993b5866ecf671b7a9ebb9384.svg";
export { ForwardRef as ReactComponent };